import { Expose } from "class-transformer";
import { IsBoolean, IsNumber } from "class-validator";

export class AddEditVindicationSetting {
  @Expose()
  @IsNumber()
  remindCount!: number;

  @Expose()
  @IsBoolean()
  isEnabled!: boolean;

  @Expose()
  @IsNumber()
  delayDayToSendRemind!: number;

  @Expose()
  @IsNumber()
  daysIntervalOfRemind!: number;

  @Expose()
  @IsBoolean()
  isPeriodRemind!: boolean;

  constructor() {
    this.isEnabled = false;
    this.delayDayToSendRemind = 15;
    this.daysIntervalOfRemind = 15;
    this.isPeriodRemind = false;
    this.remindCount = 1;
  }
}
export class VindicationSetting extends AddEditVindicationSetting {
  @Expose()
  @IsNumber()
  recordStampId!: number;

  @Expose()
  @IsNumber()
  id!: number;

  constructor() {
    super();

    this.recordStampId = 0;
  }
}
